import API from 'services/API';
import { formatAddress } from 'utils';

export default function getExternalTaxAuthority(taxCode) {
  return API.request({
    method: 'GET',
    url: `/appointment/getExternalFns?taxCode=${taxCode}`,
    mapper: function (data = null) {
      if (!data) {
        return {};
      } else {
        return {
          address: data.contacts ? formatAddress(data.contacts) : null,
          ...data,
        };
      }
    },
  });
}
